/**
 * User: herbert
 * Date: 29.02.16
 * Time: 11:42
 */

// the whole app is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */


import React from 'react';
import Reflux from 'reflux';

import finishConfig from '../../../config-finish.js';
//import finishStore from '../../finish/stores/finish-store.js';
//import finishActions from '../../finish/actions/finish-actions.js';
import FinishItem from '../../finish/components/finish-item.jsx';

import FacadeOptions from './for-summary/facade-options.jsx';
import MountingOptions from './for-summary/mounting-options.jsx';
import renderRgbwOptions from './for-summary/rgbw-options.jsx';
import VertOptions from './for-summary/vert-options.jsx';
import SpotOptions from './for-summary/spot-options.jsx';
import WegeOptions from './for-summary/wege-options.jsx';
import KameraOptions from './for-summary/kamera-options.jsx';
import kabelkastenOption from './for-summary/kabelkasten-option.jsx';
import GoboOptions from './for-summary/gobo-options.jsx';
import renderChargingLine from './for-summary/charging-line.jsx';

import steleActions from '../actions/stele-actions.js';
import steleStore from '../stores/stele-store.js';

import * as config from '../../../config.js';
import T from '../../../nls/translate.js';


export default React.createClass({
	mixins: [
		Reflux.connect(steleStore, 'data') // this.state.data entspricht parameter von trigger() bei output: des stores, hier: ein Array mit StepPart-Elementen
	],
	getInitialState: function () {
		return {};
	},
	componentWillUnmount: function () {
		this._OnSetHeight();
	},
	_OnSetHeight: function () {
		//console.log(this.refs.steleHeight.value, this.refs.steleHeight.validity.valid);
		//if(this.refs.steleHeight && this.refs.steleHeight.validity.valid)
		//	steleActions.setHeight(this.refs.steleHeight.value);
		if (this.refs.steleHeight)
			steleActions.setHeight(this.refs.steleHeight.value);
	},
	renderPart: function (k, /**StelePartCfg*/ cfg, part, parentIdx, i) {
		const options = part ?
			this.renderOptions(part, parentIdx !== null ? parentIdx : i, parentIdx !== null ? i : null) :
			null;
		return (
			<div key={k} className={'slx-stele-summary-line slx-stele-summary-line__' + cfg.name}>
				<span className="slx-stele-summary-line__title">{T.current.PRODUCTS.baseDescription[cfg.name]}</span>
				<img className="slx-stele-summary-line__icon" src={cfg.getImg(part)}/>
				<div className="slx-stele-summary-line__details">{options}</div>
			</div>
		);
	},
	/**
	 * render list of parts for a given array of SteleParts. This is recursivly called on a parts children.
	 * @param{Array.<StelePart>} parts array of parts to render
	 * @param{String} k key to add if recursivly
	 * @param{Number} parentIdx index of parent if recursily
	 * @returns{Array} array of react elements with rendered list
	 */
	renderParts: function (/***/parts, k, parentIdx) {
		let elems = [];
		parts.forEach(function (part, i) {
			elems.push(this.renderPart((k ? k : '') + elems.length, part.cfg, part, parentIdx, i));
			if (part.container) {
				const childs = this.renderParts(part.children, (elems.length) + '.', i);
				elems = elems.concat(childs);
			}
		}, this);
		return elems;
	},
	renderOptions: function (/**StelePart*/ part, parentIndex, childIndex) {
		if (parentIndex === undefined) {
			parentIndex = childIndex;
			childIndex = null;
		}
		if (part.container)
			return <MountingOptions parentIdx={parentIndex} backCover={part.backCover}/>;
		else
			switch (part.name) {
				case config.PART_ELEMENT_GOBO_NAME:
					return (
						<GoboOptions
							parentIdx={parentIndex} childIdx={childIndex}
							type={part.type}
							power={part.power}
						/>
					);
				case config.PART_DECKEL_NAME:
					return <div/>;
				case config.PART_ELEMENT_FASSADE_500_NAME:
					return (<FacadeOptions parentIdx={parentIndex} childIdx={childIndex}
										   wide={part.type === config.F_45}
										   horiz={part.horiz}
										   vert={part.vert}
										   k3000={part.k3000}
					/>);
				case config.PART_ELEMENT_VERT_NAME:
					return <VertOptions parentIdx={parentIndex} childIdx={childIndex} k3000={part.k3000}/>;
				case config.PART_ELEMENT_TWINSPOT_NAME:
					return <SpotOptions parentIdx={parentIndex} childIdx={childIndex} spot={part.a.type}
										k3000={part.k3000}/>;
				case config.PART_MODUL_RGBW_NAME:
					return renderRgbwOptions();
				case config.PART_MODUL_WEGE_NAME:
					return <WegeOptions parentIdx={parentIndex} four={true} type={part.type} k3000={part.k3000}
										k2xxx={part.k2xxx} sky={part.sky} gold={part.gold} />;
				case config.PART_MODUL_WEGE2_NAME:
					return <WegeOptions parentIdx={parentIndex} four={false} type={part.type} k3000={part.k3000}
										k2xxx={part.k2xxx} sky={part.sky} gold={part.gold} />;
				case config.PART_MODUL_KAMERA_NAME:
					return <KameraOptions parentIdx={parentIndex} type={part.type}/>;
				default:
					console.log('Unknown Part ' + part.name);
			}
		return <div/>;
	},
	render: function () {
		if (this.refs.steleHeight)
			this.refs.steleHeight.value = this.state.data.height;
		const parts = this.state.data.active;
		const deckel = (parts.length < 1 || !(parts[0].name === config.PART_MODUL_WEGE_NAME || parts[0].name === config.PART_MODUL_WEGE2_NAME)) ?
			this.renderPart(config.PART_DECKEL_NAME, config.PART_DECKEL) :
			null;

		return (
			<div className="slx-stele-summary">
				<div className="slx-stele-summary-line">
					<span className="slx-stele-summary-line__title">{T.current.SUMMARY.TITEL}</span>
				</div>
				<div className="slx-stele-summary-line">
					<span className="slx-stele-summary-line__title">{T.current.SUMMARY.BASE_CONFIGURATION}</span>
					<div className="slx-stele-summary-line__icon">
						<div className="slx-stele-summary__field" style={{backgroundColor: this.state.data.finish}}/>
					</div>
					<div className="slx-stele-summary-line__details">
						<div className="slx-stele-summary__optiongroup"
							 style={{height: 'unset', paddingBottom: '1em'}}>
							{T.current.SUMMARY.HEIGHT + ' '}
							<input ref="steleHeight" onBlur={this._OnSetHeight}
								   type="number" id="slx-stele-summery-height"
								   defaultValue={this.state.data.height}
								   required="required"
								   max="8000"
								   min={3000 + 10 * Math.round(this.state.partsHeight / 10)}
								   step="10"
							/>
							<label htmlFor="slx-stele-summery-height">mm</label>
						</div>
						<br/>
						<div className="slx-stele-summary__optiongroup"
							 style={{height: 'unset', paddingBottom: '15px'}}>
							{finishConfig.map(
								(color) => <FinishItem key={color.id} color={color} apply={true}/>
							)}</div>
						<br/>
						{/*<div className="slx-stele-summary__optiongroup" style={{height: 'unset', paddingBottom: '15px'}} >
								<input type="checkbox" id="kastentuer" /><label htmlFor="kastentuer">!!!Tür</label>
							</div>*/}
						{kabelkastenOption(this.state.data.kasten, this.state.data.extraDoors, this.state.data.neededExtraDoors)}
					</div>
				</div>
				{deckel}
				{this.renderParts(parts)}
				{renderChargingLine(this.state.data.charging)}
			</div>
		);
	}
});
